import { Button } from '@/components/ui/button'
import { NameDto } from 'api/Common/Types'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseNavigationHeader,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'

import { FormErrorMessage } from '../../../../Administration/Administration.styles'
import { getTokenizedCardStatusName } from './tokenizedCardDetailsUtils'

type EditCardStatusFormValues = {
  statusId: number
  comment: string
}

interface OuterProps {
  currentStatusId: number
  statuses: NameDto[]
  onSubmit(values: EditCardStatusFormValues): Promise<void>
  onClose(): void
}

const EditCardStatusFormUI = ({
  isValid,
  isSubmitting,
  errors,
  statuses,
  onClose,
}: FormikProps<EditCardStatusFormValues> & OuterProps) => {
  return (
    <FormBaseContainer>
      <Form>
        <FormBaseNavigationHeader style={{ justifyContent: 'flex-start' }}>
          <h3>Update Card Status</h3>
        </FormBaseNavigationHeader>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Status</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field component='select' name='statusId'>
                <option value='' disabled>
                  None
                </option>
                {statuses.map((status) => (
                  <option key={status.id} value={status.id}>
                    {getTokenizedCardStatusName(status)}
                  </option>
                ))}
              </Field>
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.statusId && <FormErrorMessage>{errors.statusId}</FormErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Comment</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field data-test='card-status-comment-field' type='text' name='comment' />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.comment && <FormErrorMessage>{errors.comment}</FormErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button key='button' type='button' onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={isSubmitting || !isValid} key='submit' type='submit'>
            Save
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

export const EditCardStatusForm = withFormik<OuterProps, EditCardStatusFormValues>({
  mapPropsToValues: ({ currentStatusId }) => ({
    statusId: currentStatusId,
    comment: '',
  }),
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit({
        statusId: Number(values.statusId),
        comment: values.comment.trim(),
      })
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<EditCardStatusFormValues> = {}

    if (!values.statusId) {
      errors.statusId = 'required'
    }
    if (!values.comment?.trim()) {
      errors.comment = 'required'
    }

    return errors
  },
  isInitialValid: false,
  enableReinitialize: true,
})(EditCardStatusFormUI)
